import { BASE_URL, MOBILE_BASE_URL } from "../api_const";

export const URL_CREATE_CALLBACK_REQUEST = BASE_URL + "/create/callback_request";
export const URL_UPDATE_NEWSLETTER_REQUEST = BASE_URL + "/newsletter/subscribe/update";
